import { useMutation } from '@tanstack/react-query'

import { verifyChallenge } from '@src/api'
import { DefaultApiVerifyChallengeRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useVerifyChallenge = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiVerifyChallengeRequest) =>
      verifyChallenge(axiosInstance, params),
  })
}
